<template>
  <section data-testid="pick-up-section">
    <div class="mx-4 md:mx-auto md:w-11/12 md:max-w-[1216px]">
      <h3 id="pick-up" class="mb-5 flex scroll-mt-20 font-Spectral text-xl tracking-wide text-gold4 md:mb-4 md:text-[30px] md:leading-[40px]">
        Pick Up
        <span class="mx-2 flex flex-grow items-center">
          <span class="h-[0.5px] flex-grow bg-gold4"></span>
        </span>
      </h3>
      <MoleculesHorizontalScrollWrapper v-if="shouldUseHorizontalScroll" scroll-button-box-style="h-[157px] md:h-full">
        <div v-for="(experience, index) in experiences" :key="experience.id">
          <OrganismsPagesEnExperienceCard
            class="mb-2 w-[280px] overflow-hidden md:w-[400px]"
            orientation="horizontal"
            theme="dark"
            :data-testid="`experience-card-${index}`"
            :display-multiple-images="false"
            :experience="experience"
            :on-experience-click="handleExperienceClick"
          />
        </div>
      </MoleculesHorizontalScrollWrapper>
      <div v-else-if="experiences.length" class="slide-scrollbar flex gap-2 overflow-x-auto md:overflow-x-visible">
        <OrganismsPagesEnExperienceCard
          v-for="(experience, index) in experiences"
          :key="experience.id"
          class="mb-2 w-[280px] shrink-0 overflow-hidden md:w-auto md:flex-1 md:shrink"
          orientation="horizontal"
          theme="dark"
          :data-testid="`experience-card-${index}`"
          :display-multiple-images="false"
          :experience="experience"
          :on-experience-click="handleExperienceClick"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import MoleculesHorizontalScrollWrapper from '@/components/molecules/HorizontalScrollWrapper/HorizontalScrollWrapper.vue';
import OrganismsPagesEnExperienceCard from '@/components/organisms/pages/en/experienceCard/EnExperienceCard.vue';
import type { ExperienceSectionViewModel } from '@/wabunka-src/features/Experience';

interface Props {
  experienceSection: ExperienceSectionViewModel;
  onExperienceClick?: (sectionId: string, experienceSlug: string) => void;
}

const props = defineProps<Props>();

// md+ コンテナ最大幅 1216px / カード幅 400px のため、3 件までは横スクロール不要。
// その場合は flex-1 で各カードを大きく表示し、4 件以上のときのみ横スクロールに切り替える。
const experiences = computed(() => props.experienceSection?.experiences ?? []);
const shouldUseHorizontalScroll = computed(() => experiences.value.length > 3);

const handleExperienceClick = (experienceSlug: string) => {
  props.onExperienceClick?.(props.experienceSection.webSectionId, experienceSlug);
};
</script>
